import $ from 'jquery';
import Masonry from 'masonry-layout';

// Frontend load
$(document).ready(function () {
  acfSolutionsGridBlock();
});

// Gutenberg load (backend)
if (window.acf && typeof window.acf.addAction === 'function') {
  // Called when the editor first loads
  window.acf.addAction('ready', function () {
    acfSolutionsGridBlock();
  });

  // Called when blocks are inserted via inserter, innerBlocks, etc.
  window.acf.addAction('append', function () {
    acfSolutionsGridBlock();
  });

  // Called whenever THIS block’s preview is (re)rendered
  window.acf.addAction(
    'render_block_preview/type=solutions-grid-block',
    function () {
      acfSolutionsGridBlock();
    }
  );
}

function acfSolutionsGridBlock() {
  $('.js-acf-solutions-grid-block').each(function () {
    const grid = this.querySelector('.solutions-grid__list');

    new Masonry(grid, {
      itemSelector: '.solutions-grid__list-item',
      columnWidth: '.grid-sizer',
      gutter: '.gutter-sizer',
      percentPosition: true,
    });
  });
}
